export default __webpack_public_path__ + "static/svg-5-672b4efcfad861038205325105554ef9.svg";